(ns pfo.coltype.controller
  (:require
   [pfo.api :as api  :refer [process-error]]
   [promesa.core :as p]
   [keechma.next.controller :as ctrl]))

(derive :collection-type-form-def :keechma/controller)
(defmethod ctrl/handle :collection-type-form-def
  [{:keys [state*] :as ctrl} event params]
  (case event
    :load (let [collection-type-id params](->> (api/ajaxp (str "/collection_types/" collection-type-id "/formdef/") {})
                                            (p/map (fn [response]
                                                     (ctrl/transact ctrl #(reset! state* response))))
                                            (process-error)))
    :load-with-callback (let [{:keys [collection-type-id on-success]} params]
                          (->> (api/ajaxp (str "/collection_types/" collection-type-id "/formdef/") {})
                            (p/map (fn [response]
                                     (ctrl/transact ctrl #(reset! state* response))
                                     (on-success response)))
                            (process-error)))
    :load-many  (let [{:keys [collection-type-ids on-success]} params]
                  (->>
                    (p/all (mapv (fn [id] (api/ajaxp (str "/collection_types/" id "/formdef/") {})) collection-type-ids))
                    (p/map (fn [results]
                             (on-success results)))
                    (process-error)))
    :clear (reset! state* nil)
    nil))
